import request from 'sb-request'
import actions from 'redux/actions'
import { reducers } from 'redux/core'
import { constants } from 'common/helpers'


const modifyGiftSetDataResponse = (data) => {
  const giftSetData = {
    ...data,
    items: data.giftsetItems,
    url: data.url,
  }

  delete giftSetData.giftsetItems
  return giftSetData
}

const modifyGiftSetsDataResponse = ({ items = [] } = {}) => ({
  items: items
    .filter((item) => item && item.id !== 1270) // ductape: it's special, should be hidden from feed, see SCNT-6301
    .map(modifyGiftSetDataResponse),
})

// TODO ask backend to add fields (price, rating) to giftSetItems gql to use graphql instead of rest/product
const _fetch = (id) =>
  request.get(`rest/product/${id}`, {
    modifyResult: modifyGiftSetDataResponse,
  })
    .then(
      (data) => data,
      () => {
        reducers.models.giftSet.setFetching(false)
        return Promise.reject()
      }
    )

const _fetchByUrl = (url) =>
  request.get(`rest/product/find?uri=${url}`, {
    modifyResult: modifyGiftSetDataResponse,
  })
    .then(
      (data) => data,
      () => {
        reducers.models.giftSet.setFetching(false)
        return Promise.reject()
      }
    )

const fetchGiftSets = (giftSetType) => {
  reducers.models.giftSet.setFetching(true)

  return request.get('rest/shop/giftsets', {
    query: {
      filterType: giftSetType,
    },
    modifyResult: modifyGiftSetsDataResponse,
  })
    .then(
      ({ items }) => {
        reducers.models.giftSet.setItems(items)
        return items
      },
      () => {
        reducers.models.giftSet.setFetching(false)
        return Promise.reject()
      }
    )
}

const fetchGiftSetByUrl = (url) => {
  reducers.models.giftSet.setFetching(true)

  return _fetchByUrl(url)
    .then((result) => {
      reducers.models.giftSet.update(result)
      return result
    })
}

const openQuickViewModal = (giftSetId) => {
  reducers.models.giftSet.setFetching(true)

  _fetch(giftSetId)
    .then((result) => reducers.models.giftSet.update(result))
    .then(() => actions.models.modals.open(constants.modals.GiftSetQuickView))
}

const showMoreInfo = ({ id, url }) => {
  reducers.models.giftSet.setFetching(true)

  _fetch(id)
    .then((result) => reducers.models.giftSet.update(result))
    .then(() => actions.models.router.push(url))
}


export default {
  openQuickViewModal,
  showMoreInfo,
  fetchGiftSets,
  fetchGiftSetByUrl,
}
